import { createSlice } from "@reduxjs/toolkit";

export const userNoteInitialState = {
  editingInProgress: false,
};

export const userNotesSlice = createSlice({
  name: "userNotes",
  initialState: userNoteInitialState,
  reducers: {
    trackNotesProgress: (state, action) => {
      state.editingInProgress = action.payload;
    },
  },
});

export const { trackNotesProgress } = userNotesSlice.actions;
